import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-financial',
  templateUrl: './financial.component.html',
  styleUrls: ['./financial.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],


})
export class FinancialComponent implements OnInit {

  columnsToDisplay3 = ['id', 'name', 'notes'];
  headercolumnsToDisplay3 = ['Id', 'Name', 'Notes'];
  dataSource3 = null;// ELEMENT_DATA3;
  expandedElement3: any | null;

  show: boolean;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }

  Financialform: FormGroup;
  submitted = false;



  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.Financialform = this.formBuilder.group({

      id: ['',],
      name: ['',],
      address: ['',],
      line1: ['',],
      line2: ['',],
      city: ['',],
      state: ['',],
      zip: ['',],
      country: ['',],
      phnum: ['',],
      notes: ['',],
      ids: ['',],
      names: ['',],
      addresss: ['',],
      linee1: ['',],
      linee2: ['',],
      cityy: ['',],
      states: ['',],
      zipp: ['',],
      countryy: ['',],
      phnnumb: ['',],
      notess: ['',],

    });
  }
  get f() { return this.Financialform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.Financialform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.Financialform.value))
  }
}




